import React, { FC } from 'react';
import { Box, useTheme } from '@mui/material';

import { BottomWrapper, NavLink, CopyRightContainer, CopyRightText, CopyRightTextPrivacy } from './styles';
import Separator from '../../assets/images/svg/separator.svg';
import Image from 'next/image';
import LocalizedLink from '../Link/localized-link';
import { useAppSelector } from '../../hooks/reduxHooks';

const CopyRight: FC = () => {
  const theme = useTheme();

  const locale = useAppSelector((d) => d.locale);

  const footerNav = [
    {
      value: locale.footer_navlink_item_7,
      url: '/about-us',
    },
    {
      value: locale.footer_navlink_item_0,
      url: '/brands',
    },
    {
      value: locale.header_items_2,
      url: '/all-watches',
    },
    {
      value: locale.header_items_3,
      url: `/sell-trade`,
    },
    {
      value: locale.footer_navlink_item_3,
      url: '/service-page',
    },
    {
      value: locale.header_items_5,
      url: '/blog',
    },
    {
      value: locale.footer_navlink_item_8,
      url: '/contact-us',
    },
  ];

  return (
    <BottomWrapper>
      <CopyRightContainer style={{ maxWidth: '90vw', width: '100%', padding: '0 100px', margin: 'auto' }}>
        <Box
          display='flex'
          justifyContent='flex-start'
          gap={'25px'}
          sx={{
            padding: { xs: '20px 0', md768: '30px 0' },
          }}
        >
          <Box
            display='flex'
            alignItems='center'
            gap='48px'
            fontSize='16px'
            sx={{
              color: { xs: '#808080', md768: '#D8D8D8' },
              [theme.breakpoints.down('md768')]: {
                width: '100%',
                justifyContent: 'space-between',
              },
            }}
          >
            <CopyRightText>{locale.footer_copyright_text}</CopyRightText>{' '}
            <CopyRightTextPrivacy>
              <LocalizedLink href='/privacy-policy'>{locale.footer_navlink_item_9}</LocalizedLink>
            </CopyRightTextPrivacy>
          </Box>
          <Box
            display='flex'
            alignItems='center'
            gap='10px'
            sx={{ display: { xs: 'none', md768: 'flex' }, marginRight: '11px' }}
          >
            {footerNav.map(({ value, url }, index) => (
              <React.Fragment key={index}>
                <NavLink key={index} href={url}>
                  {value}
                </NavLink>
                {index !== footerNav.length - 1 && <Image src={Separator} alt='Separator' key={-index - 1} />}
              </React.Fragment>
            ))}
          </Box>
        </Box>
      </CopyRightContainer>
    </BottomWrapper>
  );
};

export default CopyRight;
